import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function updateEquipment(equipmentId, updateData, prefix) {
    const token = await getOrRefreshFirebaseToken();

    const res = await axios.put(
        `${prefix}equipments/${equipmentId}`,
        updateData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return res.data;
}